<template>
  <div class="fullbg">
    <div class="login">
      <div class="logo center">
        <img src="../assets/logo.png" />
      </div>
      <div class="flex flex-between login-tabs">
        <div
          :class="['tab', activeTab == 'account' ? 'active' : '']"
          @click="selectTab('account')"
        >
          {{ $t("login.accountLogin") }}
        </div>
        <div
          :class="['tab', activeTab == 'vfcode' ? 'active' : '']"
          @click="selectTab('vfcode')"
        >
          {{ $t("login.vfcodeLogin") }}
        </div>
      </div>
      <div>
        <el-form
          ref="loginObjForm"
          :model="loginObj"
          label-width="0"
          @submit.native.prevent="loginSubmit"
        >
          <div v-if="activeTab == 'account'">
            <el-form-item
              :prop="'phone'"
              :rules="[
                { required: true, validator: validateAccount, trigger: 'blur' },
              ]"
            >
              <el-input
                v-model.trim="loginObj.phone"
                prefix-icon="el-icon-user"
                :placeholder="$t('user.account')"
                size="large"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model.trim="loginObj.password"
                prefix-icon="el-icon-lock"
                :placeholder="$t('user.password')"
                size="large"
                :prop="'password'"
                type="password"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('user.password')]),
                    trigger: 'blur',
                  },
                ]"
              />
            </el-form-item>
          </div>
          <div v-if="activeTab == 'vfcode'">
            <el-form-item
              :prop="'phone'"
              :rules="[
                { required: true, validator: validatePhone, trigger: 'blur' },
              ]"
            >
              <el-input
                v-model.trim="loginObj.phone"
                prefix-icon="el-icon-mobile-phone"
                :placeholder="$t('user.phone')"
                size="large"
                @input="checkPhone"
              >
                <el-button
                  v-if="sendDF == true"
                  slot="append"
                  type="primary"
                  disabled
                  >{{ currentLastTime }}s</el-button
                >
                <el-button
                  v-if="sendDF == false"
                  slot="append"
                  @click="sendVerificationCode"
                  >{{ $t("action.sendVfcode") }}</el-button
                >
              </el-input>
            </el-form-item>

            <el-form-item
              :prop="'_code'"
              :rules="[
                { required: true, validator: validateCode, trigger: 'blur' },
              ]"
            >
              <el-input
                v-model.trim="loginObj._code"
                prefix-icon="el-icon-postcard"
                :placeholder="$t('user.vfcode')"
                size="large"
              />
            </el-form-item>
          </div>
          <div v-if="loginErrorDF" class="red center font10 mgt10">
            {{ errorMsg }}
          </div>
          <el-form-item>
            <el-button
              type="primary"
              class="block"
              native-type="submit"
              :loading="loading"
              >{{ $t("text.login") }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="center">
        <router-link to="/register" class="font15">{{
          $t("text.register")
        }}</router-link>
      </div>
    </div>
    <div
      class="center grey-shallow font10"
      style="position: fixed; bottom: 10px; right: 42%"
    >
      <a href="https://www.jianyingkeji.com/" class="mgr10 grey-shallow"
        >关于简赢</a
      >
      <a
        href="https://www.jianyingkeji.com/privacy.html"
        class="mgr10 grey-shallow"
        >隐私政策</a
      >苏ICP备2023027899号
      <!-- 苏ICP备14043256号 -->
    </div>
  </div>
</template>

<script>
import Cookies from "../utils/cookies";
import Util from "../utils";
import { page } from "../utils/mixins";
import ls from "store2";
import User from "../api/user";
import Currency from "../api/currency";
import UserAuth from "../api/userAuth";
import Fingerprint2 from "fingerprintjs2";
import Weixin from "../api/weixin.js";
import Md5 from "../utils/md5";
import ShopifyStore from "../api/adapterShopifyStore";

export default {
  mixins: [page],
  data() {
    var validateAccount = (rule, value, callback) => {
      const self = this;
      if (value === null || value.trim() === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("user.account")]))
        );
        return;
      }
      User.findByPhone({ phone: value.trim() }).then(function (res) {
        if (res.data.code === 200) {
          callback();
        } else {
          callback(new Error(self.$t("prompt.accountNotExist")));
        }
      });
    };

    var validatePhone = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(new Error(self.$t("rules.required", [self.$t("user.phone")])));
        return;
      }
      if (!Util.regexPhone(value)) {
        callback(new Error(self.$t("rules.regex", [self.$t("user.phone")])));
        return;
      }
      User.findByPhone({ phone: value.trim() }).then(function (res) {
        if (res.data.code === 200) {
          self.user = res.data.entity;
          callback();
        } else {
          callback(new Error(self.$t("prompt.accountNotExist")));
        }
      });
    };
    var validateCode = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("user.vfcode")]))
        );
        return;
      }
      if (self.sendDF == false) {
        callback(new Error(self.$t("prompt.sendVerificationCode")));
        return;
      }

      if (value.trim() !== self.loginObj._verificationCode) {
        callback(new Error(self.$t("rules.error", [self.$t("user.vfcode")])));
        return;
      } else {
        callback();
      }
    };

    return {
      activeTab: "account",
      loginObj: {
        phone: null,
        password: null,
        _code: null,
        _verificationCode: null,
        fingerId: null,
      },
      user: null,
      Util: Util,
      validateAccount: validateAccount,
      validatePhone: validatePhone,
      validateCode: validateCode,
      sendDF: false,
      currentLastTime: 60,
      loginErrorDF: false,
      errorMsg: null,
      loading: false,
    };
  },
  computed: {
    checkPhone() {
      if (this.activeTab == "vfcode") {
        if (Util.regexPhone(this.loginObj.phone)) {
          this.loginObj._verificationCode = Util.randNNumber(4);
        }
      }
    },
  },
  created() {},
  methods: {
    selectTab(name) {
      this.activeTab = name;
      this.loginObj.phone = null;
    },
    sendVerificationCode() {
      const self = this;
      if (
        self.loginObj.phone == null ||
        self.loginObj.phone.trim() == "" ||
        !Util.regexPhone(self.loginObj.phone)
      ) {
        self.$message({
          message: self.$t("rules.regex", [self.$t("user.phone")]),
          type: "warning",
        });
        return;
      }
      User.findByPhone({ phone: self.loginObj.phone.trim() }).then(function (
        res
      ) {
        if (res.data.code === 200) {
          self.user = res.data.entity;
          const obj = {
            phone: self.loginObj.phone,
            verificationCode: self.loginObj._verificationCode,
            encryptedString: Md5.hex_md5(
              encodeURIComponent(
                self.loginObj.phone + self.loginObj._verificationCode
              )
            ),
          };
          self.sendDF = true;
          Weixin.sendVerificationCode(obj).then(function (res) {
            if (res.status === 200) {
              self.send = true;
              let wait = 60;
              const interval = window.setInterval(function () {
                self.currentLastTime = wait--;
                if (wait < 1) {
                  self.send = false;
                  window.clearInterval(interval);
                }
              }, 1000);
            }
          });
        } else {
          self.$message({
            message: self.$t("prompt.accountNotExist"),
            type: "warning",
          });
        }
      });
    },
    loginSubmit() {
      const self = this;
      self.$refs.loginObjForm.validate((valid) => {
        if (valid) {
          self.loginErrorDF = false;
          if (self.activeTab == "vfcode") {
            if (self.loginObj._code == null || self.loginObj._code == "") {
              self.loginErrorDF = true;
              self.errorMsg = self.$t("rules.required", [
                self.$t("user.vfcode"),
              ]);
              return;
            }
            if (self.sendDF == false) {
              self.loginErrorDF = true;
              self.errorMsg = self.$t("prompt.sendVerificationCode");
              return;
            }
            if (self.loginObj._code !== self.loginObj._verificationCode) {
              self.loginErrorDF = true;
              self.errorMsg = self.$t("rules.error", [this.$t("user.vfcode")]);
              return;
            }
            self.edition();
            return;
          }

          Fingerprint2.get(function (components) {
            const values = components.map(function (component, index) {
              if (index === 0) {
                // 把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
                return component.value.replace(/\bNetType\/\w+\b/, "");
              }
              return component.value;
            });
            self.loginObj.fingerId = Fingerprint2.x64hash128(
              values.join(""),
              31
            );
            self.loading = true;
            User.loginNew(self.loginObj).then(function (res) {
              self.loading = false;
              if (res.status == 200) {
                if (res.data.type == "success") {
                  self.user = res.data.data;
                  self.edition();
                } else {
                  self.loginErrorDF = true;
                  self.errorMsg = res.data.message;
                }
              } else {
                self.sysError();
              }
            });
          });
        } else {
          return false;
        }
      });
    },
    edition() {
      const self = this;
      const tenant = self.user.tenant;
      if (
        ["af", "bf"].includes(tenant.charge.edition) &&
        self.user.admin != true
      ) {
        self.errorMsg = "免费版本,子账号不能登录";
        self.loginErrorDF = true;
        return;
      }
      if (
        !["af", "bf"].includes(tenant.charge.edition) &&
        tenant.charge.availableDays <= 0
      ) {
        self.errorMsg = "该账号已到期";
        self.loginErrorDF = true;
        return;
      }

      if (self.user.voidAt != null) {
        self.errorMsg = "该账号已失效";
        self.loginErrorDF = true;
        return;
      }
      if (self.user.authorize !== true) {
        self.errorMsg = "该账号未授权";
        self.loginErrorDF = true;
        return;
      }

      Cookies.setToken(self.user.webToken);
      ls.session("TENANT", tenant);
      ls.session("USER", self.user);
      //
      if (
        tenant.charge.extendModelNew != null &&
        JSON.parse(tenant.charge.extendModelNew).includes("mms")
      ) {
        self.getUserAuthsMms(self.user.id);
      }
      if (
        tenant.charge.extendModelNew != null &&
        JSON.parse(tenant.charge.extendModelNew).includes("mes")
      ) {
        self.getUserAuthsMes(self.user.id);
      }
      self.getCurrency();
    },
    //币种
    getCurrency() {
      const self = this;
      Currency.findByTenantId().then(function (res) {
        if (res.status === 200) {
          ls.session("CURRENCIES", res.data);
          self.loading = false;
          self.loginError = false;
          // 登录
          // self.$router.push("/normal/dashboard");

          if (Cookies.getShopifyHrefShop() && Cookies.getShopifyHrefCode()) {
            self.shopifyStoreAccessTokenFun();
          } else {
            self.$router.push("/normal/dashboard");
          }
          // if (
          //   Cookies.getToken() &&
          //   Util.parseQueryString(window.location.href, "shop") != null
          // ) {
          //   self.shopifyInstallByNameFun();
          // } else {
          //   self.$router.push("/normal/dashboard");
          // }
        } else {
          self.sysError();
        }
      });
    },
    shopifyStoreAccessTokenFun() {
      const self = this;
      const obj = {
        code: Cookies.getShopifyHrefCode(),
        shop: Cookies.getShopifyHrefShop(),
      };
      self.saveSubmitDing = true;
      ShopifyStore.accessToken(obj).then(function (res) {
        if (res.status === 200) {
          self.saveSubmitDing = false;
          self.$message({
            message: self.$t("prompt.authorizeSuccess"),
            type: "success",
          });
          self.$router.push({ name: "adapterShopifys" });
          Cookies.removeShopifyHrefShop();
          Cookies.removeShopifyHrefCode();
        } else {
          self.sysError();
        }
      });
    },
    // 物料权限
    getUserAuthsMms(userId) {
      UserAuth.findByIdMms(userId).then((userAuthsMmsRes) => {
        if (userAuthsMmsRes.data.code === 200) {
          const userAuthsMms = userAuthsMmsRes.data.entity;
          ls.session(
            "MMSAUTHSUNJECTIDS",
            JSON.parse(userAuthsMms.subjectsJson || "[]")
          );
          ls.session(
            "MMSUSERAUTHS",
            JSON.parse(userAuthsMms.actionsJson || "[]")
          );
        } else {
          // 其他是没有授权的
        }
      });
    },
    // 工厂权限
    getUserAuthsMes(userId) {
      UserAuth.findByIdMes(userId).then((userAuthsMesRes) => {
        if (userAuthsMesRes.data.code === 200) {
          const userAuthsMes = userAuthsMesRes.data.entity;
          ls.session(
            "MESAUTHPHASEIDS",
            JSON.parse(userAuthsMes.phasesJson || "[]")
          );
          ls.session(
            "MESUSERAUTHS",
            JSON.parse(userAuthsMes.actionsJson || "[]")
          );
        } else {
          // 其他是没有授权的
        }
      });
    },
  },
};
</script>
<style scoped>
.logo {
  margin-bottom: 50px;
}
.logo img {
  width: 180px;
}
.fullbg {
  background: #ffffff;
  height: 100vh;
  width: 100%;
}
.login {
  width: 400px;
  margin: 0 auto;
  padding-top: 120px;
}
.login-tabs {
  margin-bottom: 20px;
}
.login-tabs .tab {
  width: 50%;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #e4e7ee;
  cursor: pointer;
}
.login-tabs .tab.active {
  color: #3198ff;
  font-weight: bold;
  border-bottom: 2px solid #3198ff;
}
</style>